import React from "react";
import Section from "@/components/ui/section";
import { IconBox } from "../country/key-facts";
export default function HowWeDoIt() {
  const data = [
    {
      icon: "/images/icons/resilience.png",
      title: "",
      description:
        "Build resilience of migrants, informal workers, and vulnerable communities through climate-responsive social protection",
    },
    {
      icon: "/images/icons/consolidate.png",
      title: "",
      description:
        "Strengthen grassroots organizations' resilience through capacity building ",
    },
    {
      icon: "/images/icons/preventive.png",
      title: "",
      description:
        "Prevent sexual violence against women and children with a focus on prevention",
    },
  ];
  return (
    <Section className="bg-[#F4F9FF]" variant="flat">
      <h2 className="text-darkBlue md:text-left !text-center">How we do it</h2>
      <p className="text-center mt-2">
        We support organizations working across South and Southeast Asia to:
      </p>

      <div className="grid lg:grid-cols-3 grid-cols-1 auto-rows-auto gap-4 w-full mt-12">
        {data.map((row, key) => (
          <IconBox
            data={row}
            key={"how-we-dot-it" + key}
            textPosition={"text-justify"}
          />
        ))}
      </div>
      <div id="vision-mission-and-aims"></div>
    </Section>
  );
}
